import { format, formatDistanceToNowStrict, parseISO } from "date-fns";

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return format(parseISO(iso), "dd MMM yyyy"); } catch { return iso; }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try { return format(parseISO(iso), "dd MMM yyyy, HH:mm"); } catch { return iso; }
}

export function fmtRelative(iso) {
  if (!iso) return "—";
  try { return formatDistanceToNowStrict(parseISO(iso), { addSuffix: true }); } catch { return iso; }
}

export function fmtINR(n) {
  if (n == null || Number.isNaN(n)) return "₹0";
  try {
    return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
  } catch {
    return `₹${Math.round(n).toLocaleString("en-IN")}`;
  }
}
